import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./index.scss";
import "antd/dist/antd.min.css";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { useGetUserDataQuery } from "../../services/login";
import { useDispatch, useSelector } from "react-redux";
import { removeToCart, removeUserToState, addCartToken } from "../../Reducers/authReducer";

function Pages(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { userId, userToken, userName, userEmail, languageCode, countryCode, cartToken } = useSelector(
    (state) => state.auth
  );
  const Components = props.Components;
  const checkuser = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    if (!cartToken) {
      dispatch(
        addCartToken({
          cartToken: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
        })
      );
    }
  }, [cartToken]);

  useEffect(() => {
    if (userId && userToken) {
      if (checkuser?.isSuccess) {
        if (checkuser?.data?.user) {
          if (checkuser?.data?.user?.user_token !== userToken) {
            dispatch(removeToCart());
            dispatch(removeUserToState());
          }
          if (checkuser?.data?.user?.status === 0) {
            dispatch(removeToCart());
            dispatch(removeUserToState());
          }
        }
      }
    }
  }, [userId, userToken, checkuser]);

  let fontFamilyForAll;
  if (languageCode === "ar") {
    fontFamilyForAll = "GessTwoMedium, sans-serif";
  } else if (languageCode === "urdu") {
    fontFamilyForAll = "AlQalam Shakir";
  } else {
    fontFamilyForAll = "Poppins, sans-serif";
  }

  const fontFamily_Text = {
    textAlign: languageCode === "ar" || languageCode === "urdu" ? "right" : "left",
    fontFamily: fontFamilyForAll,
    display: "block",
    minHeight: "100vh",
    position: "relative",
  };

  return (
    <>
      <div style={fontFamily_Text}>
        {props.header && <Header />}
        <Components />
        {props.footer && <Footer />}
      </div>
    </>
  );
}

export default Pages;
